export const icon = {
  longArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="22"
      viewBox="0 0 39 22"
      fill="none"
    >
      <path
        d="M30.2274 5.43579L35.7916 11L30.2274 16.5641"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.41663 11L35.3333 11"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  play: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
    >
      <path d="M15 9.42969L0 18.0899L0 0.769433L15 9.42969Z" fill="white" />
    </svg>
  ),
  facebook: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
    >
      <path
        d="M2.39088 15.5504H5.23855V8.45554H7.6197L7.97931 5.69534H5.23855V3.92648C5.23855 3.12952 5.46208 2.58526 6.60893 2.58526H8.0765V0.106909C7.8238 0.077752 6.95881 0 5.94803 0C3.82929 0 2.39088 1.29263 2.39088 3.65435V5.69534H0V8.45554H2.39088V15.5504Z"
        fill="white"
      />
    </svg>
  ),
  linkedin: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5562 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516Z"
        fill="#565656"
      />
    </svg>
  ),
  twitter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.55016 21.75C16.6045 21.75 21.5583 14.2467 21.5583 7.74186C21.5583 7.53092 21.5536 7.3153 21.5442 7.10436C22.5079 6.40746 23.3395 5.54425 24 4.5553C23.1025 4.9546 22.1496 5.21538 21.1739 5.32874C22.2013 4.71291 22.9705 3.74547 23.3391 2.60577C22.3726 3.17856 21.3156 3.58261 20.2134 3.80061C19.4708 3.01156 18.489 2.48912 17.4197 2.31405C16.3504 2.13899 15.2532 2.32105 14.2977 2.8321C13.3423 3.34314 12.5818 4.15471 12.1338 5.14131C11.6859 6.12792 11.5754 7.23462 11.8195 8.2903C9.86249 8.19209 7.94794 7.6837 6.19998 6.7981C4.45203 5.91249 2.90969 4.66944 1.67297 3.14952C1.0444 4.23324 0.852057 5.51565 1.13503 6.73609C1.418 7.95654 2.15506 9.02345 3.19641 9.71999C2.41463 9.69517 1.64998 9.48468 0.965625 9.10592V9.16686C0.964925 10.3041 1.3581 11.4066 2.07831 12.2868C2.79852 13.167 3.80132 13.7706 4.91625 13.995C4.19206 14.1931 3.43198 14.222 2.69484 14.0794C3.00945 15.0574 3.62157 15.9129 4.44577 16.5263C5.26997 17.1398 6.26512 17.4806 7.29234 17.5012C5.54842 18.8711 3.39417 19.6141 1.17656 19.6106C0.783287 19.61 0.390399 19.5859 0 19.5384C2.25286 20.9837 4.87353 21.7514 7.55016 21.75Z"
        fill="#565656"
      />
    </svg>
  ),
  instragram: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.2068 0C12.8443 0 13.1759 0.0125 14.2122 0.06C15.2485 0.11 15.9544 0.2775 16.5727 0.525C17.2214 0.776024 17.8089 1.16978 18.2942 1.67875C18.7886 2.17837 19.1712 2.7828 19.4155 3.45C19.6561 4.085 19.8201 4.8125 19.8675 5.875C19.9136 6.94375 19.9258 7.28375 19.9258 10.0013C19.9258 12.7163 19.9136 13.0563 19.8675 14.1225C19.8189 15.1875 19.6561 15.9138 19.4155 16.55C19.1665 17.2075 18.8348 17.765 18.2942 18.3213C17.7548 18.8775 17.213 19.22 16.5739 19.475C15.9544 19.7225 15.2497 19.8912 14.2146 19.94C13.1771 19.9875 12.8467 20 10.2068 20C7.56685 20 7.23762 19.9875 6.20011 19.94C5.16625 19.89 4.45798 19.7225 3.83961 19.475C3.19139 19.2239 2.6043 18.8301 2.11934 18.3213C1.57872 17.765 1.24706 17.2075 0.998013 16.55C0.758682 15.9138 0.594675 15.1875 0.54608 14.1225C0.499914 13.0563 0.487764 12.7163 0.487764 10C0.487764 7.28375 0.499914 6.94375 0.54608 5.87625C0.594675 4.8125 0.758682 4.085 0.998013 3.45C1.2423 2.78278 1.62495 2.17834 2.11934 1.67875C2.60453 1.16959 3.19209 0.775807 3.84082 0.525C4.46041 0.2775 5.16747 0.10875 6.20133 0.06C7.23883 0.0125 7.56806 0 10.2092 0H10.2056H10.2068ZM11.0778 1.8025H10.2056C7.61058 1.8025 7.30322 1.81125 6.27908 1.86C5.33148 1.90375 4.81637 2.0675 4.47377 2.20375C4.02062 2.385 3.69625 2.6025 3.35609 2.9525C3.01592 3.3025 2.80575 3.635 2.62959 4.1025C2.49595 4.45375 2.33802 4.98375 2.2955 5.95875C2.24812 7.0125 2.2384 7.32875 2.2384 9.9975C2.2384 12.6663 2.24812 12.9838 2.2955 14.0375C2.33802 15.0125 2.49717 15.5413 2.62959 15.8938C2.78541 16.3279 3.03411 16.7205 3.3573 17.0425C3.69747 17.3925 4.02062 17.6088 4.47499 17.79C4.81515 17.9275 5.33026 18.09 6.27908 18.135C7.30322 18.1825 7.61058 18.1938 10.2056 18.1938C12.8005 18.1938 13.1091 18.1825 14.1333 18.135C15.0809 18.09 15.5947 17.9275 15.9373 17.79C16.3595 17.6299 16.7414 17.3745 17.055 17.0425C17.3785 16.72 17.6276 16.3271 17.784 15.8925C17.9164 15.5413 18.0755 15.0113 18.118 14.0363C18.1642 12.9825 18.1739 12.6663 18.1739 9.995C18.1739 7.325 18.1642 7.01 18.118 5.95625C18.0743 4.98125 17.9164 4.45125 17.7827 4.09875C17.6066 3.6325 17.3952 3.29875 17.055 2.94875C16.7149 2.59875 16.3917 2.3825 15.9373 2.20125C15.5947 2.06375 15.0809 1.90125 14.1333 1.85625C13.2367 1.81375 12.8892 1.80125 11.0778 1.8V1.8025ZM5.01804 3.4625C5.1712 3.4625 5.32285 3.49354 5.46435 3.55384C5.60585 3.61415 5.73442 3.70254 5.84272 3.81397C5.95102 3.9254 6.03693 4.05769 6.09554 4.20328C6.15415 4.34887 6.18432 4.50491 6.18432 4.6625C6.18432 4.82009 6.15415 4.97613 6.09554 5.12172C6.03693 5.26731 5.95102 5.3996 5.84272 5.51103C5.73442 5.62246 5.60585 5.71085 5.46435 5.77116C5.32285 5.83146 5.1712 5.8625 5.01804 5.8625C4.70872 5.8625 4.41207 5.73607 4.19335 5.51103C3.97463 5.28598 3.85176 4.98076 3.85176 4.6625C3.85176 4.34424 3.97463 4.03902 4.19335 3.81397C4.41207 3.58893 4.70872 3.4625 5.01804 3.4625ZM10.2056 4.865C10.8676 4.85437 11.525 4.97936 12.1397 5.23268C12.7543 5.486 13.3138 5.86259 13.7856 6.34053C14.2574 6.81847 14.6321 7.38821 14.8879 8.01658C15.1436 8.64494 15.2754 9.31938 15.2754 10.0006C15.2754 10.6819 15.1436 11.3563 14.8879 11.9847C14.6321 12.613 14.2574 13.1828 13.7856 13.6607C13.3138 14.1387 12.7543 14.5153 12.1397 14.7686C11.525 15.0219 10.8676 15.1469 10.2056 15.1363C8.89526 15.1152 7.64556 14.5649 6.72618 13.6041C5.80681 12.6432 5.29151 11.349 5.29151 10.0006C5.29151 8.65228 5.80681 7.35802 6.72618 6.39719C7.64556 5.43636 8.89526 4.88603 10.2056 4.865ZM10.2056 6.66625C9.34624 6.66625 8.52211 7.01748 7.91448 7.64268C7.30685 8.26788 6.96548 9.11584 6.96548 10C6.96548 10.8842 7.30685 11.7321 7.91448 12.3573C8.52211 12.9825 9.34624 13.3338 10.2056 13.3338C11.0649 13.3338 11.889 12.9825 12.4966 12.3573C13.1043 11.7321 13.4456 10.8842 13.4456 10C13.4456 9.11584 13.1043 8.26788 12.4966 7.64268C11.889 7.01748 11.0649 6.66625 10.2056 6.66625Z"
        fill="white"
      />
    </svg>
  ),
  dribble: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.37527 0 0 5.37527 0 12C0 18.6248 5.37527 24 12 24C18.6117 24 24 18.6248 24 12C24 5.37527 18.6117 0 12 0ZM19.9262 5.53145C21.3579 7.27549 22.217 9.50107 22.243 11.9089C21.9046 11.8439 18.5206 11.154 15.1106 11.5835C15.0325 11.4143 14.9675 11.2321 14.8894 11.0499C14.6811 10.5554 14.4469 10.0477 14.2126 9.56618C17.9869 8.0304 19.705 5.81779 19.9262 5.53145ZM12 1.77007C14.603 1.77007 16.9848 2.74621 18.7939 4.34707C18.6117 4.60738 17.0629 6.67679 13.4186 8.04338C11.7397 4.95878 9.87855 2.43384 9.5922 2.04338C10.3601 1.86117 11.1671 1.77007 12 1.77007ZM7.63995 2.73319C7.91325 3.09761 9.73538 5.63558 11.4404 8.65508C6.65076 9.9306 2.42083 9.90458 1.96529 9.90458C2.62907 6.72885 4.77657 4.08676 7.63995 2.73319ZM1.74404 12.0131C1.74404 11.9089 1.74404 11.8048 1.74404 11.7007C2.18655 11.7136 7.15835 11.7787 12.2733 10.243C12.5727 10.8156 12.846 11.4013 13.1063 11.9869C12.9761 12.026 12.8329 12.0651 12.7028 12.1041C7.41865 13.8091 4.60738 18.4685 4.3731 18.859C2.7462 17.0499 1.74404 14.6421 1.74404 12.0131ZM12 22.256C9.6312 22.256 7.44469 21.449 5.71367 20.0954C5.89588 19.718 7.97827 15.7094 13.757 13.692C13.783 13.679 13.7961 13.679 13.8221 13.666C15.2668 17.4013 15.8525 20.5379 16.0087 21.436C14.7722 21.9696 13.4186 22.256 12 22.256ZM17.7136 20.4989C17.6096 19.8742 17.0629 16.8807 15.7223 13.1974C18.9371 12.6898 21.7484 13.5228 22.0998 13.6399C21.6573 16.4902 20.0173 18.9501 17.7136 20.4989Z"
        fill="#565656"
      />
    </svg>
  ),
  long_round_icon: (
    <svg
      width="47"
      height="32"
      viewBox="0 0 47 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31" cy="16" r="15.25" stroke="#222" strokeWidth="1.5" />
      <path
        d="M30.2275 10.4358L35.7917 16L30.2275 21.5641"
        stroke="#222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.41669 16L35.3334 16"
        stroke="#222"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  downloadArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
    >
      <path
        d="M1.3755 16.0834H12.6238C12.7821 16.0837 12.9344 16.144 13.05 16.2522C13.1655 16.3603 13.2357 16.5083 13.2464 16.6662C13.2571 16.8242 13.2074 16.9803 13.1075 17.103C13.0076 17.2258 12.8648 17.306 12.708 17.3276L12.6238 17.3334H1.3755C1.21602 17.3351 1.06195 17.2756 0.944845 17.1674C0.82774 17.0591 0.756457 16.9102 0.745593 16.751C0.73473 16.5919 0.785108 16.4347 0.88641 16.3115C0.987713 16.1883 1.13228 16.1085 1.2905 16.0884L1.3755 16.0834ZM6.903 0.668431L7.0005 0.662598C7.20461 0.662625 7.40161 0.737561 7.55414 0.873194C7.70667 1.00883 7.80412 1.19572 7.828 1.39843L7.83383 1.49593V11.9876L10.5788 9.24343C10.7223 9.09995 10.9132 9.01376 11.1158 9.00102C11.3183 8.98829 11.5185 9.04989 11.6788 9.17426L11.7572 9.24426C11.9006 9.38776 11.9868 9.57868 11.9996 9.7812C12.0123 9.98372 11.9507 10.1839 11.8263 10.3443L11.7572 10.4226L7.593 14.5859C7.44961 14.7295 7.25875 14.8159 7.05622 14.8288C6.8537 14.8417 6.65343 14.7802 6.493 14.6559L6.41466 14.5868L2.24466 10.4226C2.09362 10.273 2.00547 10.0713 1.99826 9.85881C1.99105 9.64633 2.06533 9.43913 2.20589 9.27961C2.34644 9.1201 2.54265 9.02035 2.75435 9.00076C2.96605 8.98118 3.17723 9.04325 3.34466 9.17426L3.423 9.24343L6.16716 11.9834V1.49593C6.16719 1.29182 6.24213 1.09482 6.37776 0.942288C6.51339 0.789758 6.70029 0.692312 6.903 0.668431Z"
        fill="currentColor"
      />
    </svg>
  ),
};
